import {
  API_SEARCH_SOCIAL,
  API_CENTRAL_MONITORING
} from 'constants/ApiUrls'
import {
  METHOD_GET,
  METHOD_POST,
  METHOD_PUT,
  METHOD_DELETE
} from 'constants/Methods'
import { createApi } from 'utils/index'

export const apiSearchTwitter = (text, type = 'text') =>
  createApi(`${API_SEARCH_SOCIAL}/twitter/${text}/${type}`, METHOD_GET)

export const apiSearchIG = (text, type = 'text') =>
  createApi(`${API_SEARCH_SOCIAL}/ig/${text}/${type}`, METHOD_GET)

export const apiSearchYoutube = (text, type = 'text') =>
  createApi(`${API_SEARCH_SOCIAL}/youtube/${text}/${type}`, METHOD_GET)

export const apiSearchPantip = (text, type = 'text') =>
  createApi(`${API_SEARCH_SOCIAL}/pantip/${text}/${type}`, METHOD_GET)

export const apiSearchFacebook = (text, type, token, searchtype = 'text') =>
  createApi(
    `${API_SEARCH_SOCIAL}/facebook/${type}/${text}/${token}/${searchtype}`,
    METHOD_GET
  )

export const apiSearchFBFromURL = (url) =>
  createApi(
    `${API_SEARCH_SOCIAL}/facebook/fromURL/${encodeURIComponent(url)}`,
    METHOD_GET
  )

export const apiSearchTiktok = (text, type = 'text') =>
  createApi(`${API_SEARCH_SOCIAL}/tiktok/${text}/${type}`, METHOD_GET)

export const apiSearchLineVoom = (text) =>
  createApi(`${API_SEARCH_SOCIAL}/line_voom`, METHOD_POST, { text })

export const apiSearchInstagram = (text, type = 'text') =>
  createApi(`${API_SEARCH_SOCIAL}/instagram/${text}/${type}`, METHOD_GET)

export const apiSearchDuckDuckGoAutocomplete = (query) =>
  createApi(`${API_SEARCH_SOCIAL}/duckduckgo/autocomplete/${encodeURIComponent(query)}`, METHOD_GET)

export const apiListMonitoring = () =>
  createApi(API_CENTRAL_MONITORING, METHOD_GET)

export const apiAddMonitoring = data =>
  createApi(API_CENTRAL_MONITORING, METHOD_POST, data)

export const apiDeleteMonitoring = id =>
  createApi(`${API_CENTRAL_MONITORING}/${id}`, METHOD_DELETE)

export const apiUpdateMonitoring = data =>
  createApi(
    `${API_CENTRAL_MONITORING}/${data._id}`,
    METHOD_PUT,
    data
  )
